
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import UpdateButton from '@/components/UpdateButton.vue';

@Component({
  components: {
    UpdateButton,
  },
})
export default class TaskEditDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean

  // Il titolo del dialog
  @Prop({ type: String, default: null }) readonly title!: string | null

  // La larghezza massima del dialog
  @Prop({ type: String, default: '600' }) readonly maxWidth!: string

  dialog = false

  // TODO: Ha senso veridicare la validità del form? Al momento non lo faccio
  valid = false

  // Il Task è in caricamento?
  get loading(): boolean {
    return this.$store.getters.isTaskLoading;
  }

  // È necessario salvare le modifiche al Task?
  get dirty(): boolean {
    return this.$store.getters.isTaskDirty;
  }

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  onCancel() {
    console.log(`${this.constructor.name}: onCancel()`); // eslint-disable-line no-console

    // Chiude il dialog
    this.dialog = false;

    // Comunica al componente padre che le modifiche sono state annullate
    this.$emit('cancel');
  }

  async onSave() {
    console.log(`${this.constructor.name}: onSave()`); // eslint-disable-line no-console

    // Avvia il salvataggio delle modifiche al Task
    await this.$store.dispatch('updateSelectedTask');

    // Chiude il dialog
    this.dialog = false;

    // Comunica al componente padre che le modifiche sono state salvate
    this.$emit('save');
  }
}
